import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ClientSessionStorage, IUser, LocalStorage, LoginService } from "@geolib/geoappbase-client";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthenticationService } from "./AuthenticationService";

@Injectable({ providedIn: "root" })
export class GeobusLoginService extends LoginService {

    public constructor(
        httpClient: HttpClient,
        clientSessionStorage: ClientSessionStorage,
        localStorage: LocalStorage,
        private readonly authenticationService: AuthenticationService,
    ) {
        super(httpClient, clientSessionStorage, localStorage);
    }

    public getCurrentUser(): Observable<IUser | undefined> {
        return this.authenticationService.getUser().pipe(
            map((response) => {
                return {
                    id: response.user.id as unknown as number,
                    username: response.user.username,
                    passwordNeverExpires: true,
                } as IUser;
            }),
        );
    }

}
